import Main from "./components/Main";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import NavBar from "./components/NavBar";
import React from "react";
import AboutPage from "./components/AboutPage";
import ExperiencePage from "./components/ExperiencePage";
import ProjectsPage from "./components/ProjectsPage";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  document.title = "Alif Hakimi";
  return (
    <div className="text-3xl font-bold mx-auto max-w-5xl my-0 z-0 overflow-x-hidden">
      <Router>
        <NavBar />
        <ScrollToTop />
        <div className="app overflow-x-hidden">
          <Routes>
            <Route path="/" element={<Main />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/experience" element={<ExperiencePage />} />
            <Route path="/projects" element={<ProjectsPage />} />
          </Routes>
        </div>
      </Router>
    </div>
  );
}

export default App;
